import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "owa-account-store-init", webpackPrefetch: true */ './lazyIndex')
);
export const lazyInitializeOwaAccountsStore = new LazyAction(
    lazyModule,
    m => m.initializeOwaAccountsStore
);

export { owaConnectedAccountAdded } from './actions/publicActions';
